import { render, staticRenderFns } from "./Expositors.vue?vue&type=template&id=c22fdec0"
import script from "./Expositors.vue?vue&type=script&lang=js"
export * from "./Expositors.vue?vue&type=script&lang=js"
import style0 from "./Expositors.vue?vue&type=style&index=0&id=c22fdec0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports